<div [formGroup]="group" class="u-flex-column w100p u-margin-bottom-double">

    <app-label-container [id]="question.id" [label]="question | questionTitle" [hasMargin]="true">
        <div formGroupName="location">
            <ui-searchable-dropdown-input
                [style.width]="'auto'"
                formControlName="value"
                [hasMarginDouble]="false"
                [hasMargin]="true"
                [label]="'UI.LOCATIONS.REVIEW_FORM_LABEL' | translate"
                [placeholder]="'UI.SEARCH' | translate"
                [multiple]="false"
                [options]="locationOptions"
                [showOverflowValuesAsCount]="true"
                [includeOtherOption]="true"
                data-testid="contact-person-location"
            ></ui-searchable-dropdown-input>
        </div>

        <ng-container formGroupName="linkedRealEstateAgents">
            <ui-searchable-dropdown-input
                [style.width]="'auto'"
                formControlName="value"
                [hasMarginDouble]="false"
                [hasMargin]="false"
                [placeholder]="'UI.SEARCH' | translate"
                [label]="'UI.AGENTS.REVIEW_FORM_LABEL' | translate"
                [multiple]="true"
                [options]="agentOptions"
                [otherOptions]="agentOptionsOthers"
                [otherOptionsGroupName]="'OTHER'"
                [showOverflowValuesAsCount]="true"
                [includeOtherOption]="true"
                data-testid="contact-person-real-estate-agent"
            ></ui-searchable-dropdown-input>
        </ng-container>
    </app-label-container>
</div>
